module.exports = __webpack_public_path__ + "img/zwischenzeiten9.bc95ed67.jpg";